import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axiosInstance from '../../main/axios';
import { toastr } from 'react-redux-toastr';
import MapaGoogle from '../../mapa/mapaGoogle';
import { Marker, InfoWindow } from 'react-google-maps';
import { openOsFromMap, iniciarOs, finalizarOs } from '../ordem_servico/ordemServicoActions';
import OrdemServicoFinalizarModal from '../ordem_servico/ordemServicoFinalizarModal';
import {
  formatSlaRestante,
  isSlaVencido,
  podeFinalizarOs,
  podeIniciarOs,
  temSlaAtivo,
} from '../ordem_servico/ordemServicoUtils';

const STATUS_LABELS = {
  ABERTA: 'Aberta',
  AGUARDANDO_MATERIAL: 'Aguard. material',
  EM_ATENDIMENTO: 'Em atendimento',
  AGUARDANDO_VALIDACAO: 'Aguard. validação',
  FINALIZADA: 'Finalizada',
  CANCELADA: 'Cancelada',
};

const PRIORIDADE_LABELS = {
  BAIXA: 'Baixa',
  MEDIA: 'Média',
  ALTA: 'Alta',
  CRITICA: 'Crítica',
};

const TIPO_LABELS = {
  CORRETIVA: 'Corretiva',
  PREVENTIVA: 'Preventiva',
  IMPLANTACAO: 'Implantação',
  RECLAMACAO: 'Reclamação',
};

const PIN_POR_PRIORIDADE = {
  CRITICA: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
  ALTA: 'https://maps.google.com/mapfiles/ms/icons/orange-dot.png',
  MEDIA: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
  BAIXA: 'https://maps.google.com/mapfiles/ms/icons/ltblue-dot.png',
};

const PRIORIDADE_BADGE_CLASS = {
  CRITICA: 'mapa-os-prioridade-badge--critica',
  ALTA: 'mapa-os-prioridade-badge--alta',
  MEDIA: 'mapa-os-prioridade-badge--media',
  BAIXA: 'mapa-os-prioridade-badge--baixa',
};

const STATUS_BADGE_CLASS = {
  ABERTA: 'mapa-os-status-badge--blue',
  AGUARDANDO_MATERIAL: 'mapa-os-status-badge--amber',
  EM_ATENDIMENTO: 'mapa-os-status-badge--violet',
  AGUARDANDO_VALIDACAO: 'mapa-os-status-badge--teal',
  FINALIZADA: 'mapa-os-status-badge--green',
  CANCELADA: 'mapa-os-status-badge--gray',
};

const TIPO_BADGE_CLASS = {
  CORRETIVA: 'mapa-os-tipo-badge--corretiva',
  PREVENTIVA: 'mapa-os-tipo-badge--preventiva',
  IMPLANTACAO: 'mapa-os-tipo-badge--implantacao',
  RECLAMACAO: 'mapa-os-tipo-badge--reclamacao',
};

function formatEquipeResponsavel(os) {
  const partes = [];
  if (os.equipe_nome) partes.push(os.equipe_nome);
  if (os.nome_usuario_responsavel) partes.push(os.nome_usuario_responsavel);
  return partes.length > 0 ? partes.join(' · ') : null;
}

function formatUltimaInteracao(os) {
  if (!os.ultima_interacao_data) return null;
  const data = new Date(os.ultima_interacao_data).toLocaleString('pt-BR');
  if (os.ultima_interacao_usuario) {
    return `${data} — ${os.ultima_interacao_usuario}`;
  }
  return data;
}

function parseCoord(value) {
  if ((value === null || value === undefined) || value === '') return NaN;
  if (typeof value === 'number') return value;
  const normalized = String(value).trim().replace(',', '.');
  return parseFloat(normalized);
}

function iconePonto(ponto) {
  return PIN_POR_PRIORIDADE[ponto.prioridade_maxima] || PIN_POR_PRIORIDADE.MEDIA;
}

function centroValido(centro) {
  const lat = parseCoord(centro && centro.latitude);
  const lng = parseCoord(centro && centro.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  if (Math.abs(lat) <= 1 && Math.abs(lng) <= 1) return false;
  return true;
}

function normalizarPontos(pontos) {
  return (pontos || [])
    .map(ponto => {
      const latitude = parseCoord(ponto.latitude);
      const longitude = parseCoord(ponto.longitude);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
      return { ...ponto, latitude, longitude };
    })
    .filter(Boolean);
}

class MapaOrdemServico extends Component {
  constructor(props) {
    super(props);
    this.state = {
      centro: null,
      centroFallback: null,
      pontos: [],
      opcoes: { grupos_fisicos: [], equipes: [] },
      filtros: {
        status: '',
        prioridade: '',
        equipe_id: '',
        grupo_fisico_id: '',
      },
      totalOs: 0,
      totalPontos: 0,
      loading: false,
      googleMapsReady: typeof window !== 'undefined' && !!(window.google && window.google.maps),
      markerAberto: null,
      osTabAtiva: 0,
    };
    this.mapRef = null;
    this.pontosBoundsKey = '';
    this.carregarOpcoes = this.carregarOpcoes.bind(this);
    this.carregarMapa = this.carregarMapa.bind(this);
    this.carregarCentroFallback = this.carregarCentroFallback.bind(this);
    this.handleFiltroChange = this.handleFiltroChange.bind(this);
    this.abrirMarker = this.abrirMarker.bind(this);
    this.fecharMarker = this.fecharMarker.bind(this);
    this.renderMarkers = this.renderMarkers.bind(this);
    this.renderInfoRow = this.renderInfoRow.bind(this);
    this.renderInfoWindow = this.renderInfoWindow.bind(this);
    this.onMapLoad = this.onMapLoad.bind(this);
    this.ajustarMapaAosPontos = this.ajustarMapaAosPontos.bind(this);
    this.abrirOs = this.abrirOs.bind(this);
    this.handleIniciarOs = this.handleIniciarOs.bind(this);
    this.handleFinalizarOs = this.handleFinalizarOs.bind(this);
    this.renderOsBadges = this.renderOsBadges.bind(this);
    this.renderOsPanel = this.renderOsPanel.bind(this);
    this.selecionarOsTab = this.selecionarOsTab.bind(this);
  }

  componentDidMount() {
    this.carregarOpcoes();
    this.carregarMapa();

    if (!this.state.googleMapsReady) {
      this.googleMapsReadyInterval = setInterval(() => {
        if (typeof window !== 'undefined' && window.google && window.google.maps) {
          clearInterval(this.googleMapsReadyInterval);
          this.googleMapsReadyInterval = null;
          this.setState({ googleMapsReady: true });
        }
      }, 300);
    }
  }

  componentDidUpdate(prevState) {
    if (prevState.pontos !== this.state.pontos && this.mapRef) {
      this.ajustarMapaAosPontos(this.mapRef);
    }
  }

  componentWillUnmount() {
    if (this.googleMapsReadyInterval) {
      clearInterval(this.googleMapsReadyInterval);
    }
  }

  carregarOpcoes() {
    axiosInstance
      .get('/manutencao/opcoes')
      .then(resp => {
        this.setState({
          opcoes: {
            grupos_fisicos: resp.data.grupos_fisicos || [],
            equipes: resp.data.equipes || [],
          },
        });
      })
      .catch(() => toastr.error('Erro', 'Não foi possível carregar os filtros.'));
  }

  carregarCentroFallback(grupoFisicoId) {
    const grupo = grupoFisicoId ? parseInt(grupoFisicoId, 10) : 0;
    return axiosInstance.get(`/fasesgeral/mapa/inicio/${grupo}`).then(resp => {
      const data = resp.data || {};
      if (centroValido(data)) {
        this.setState({ centroFallback: data });
      } else {
        this.setState({ centroFallback: null });
      }
    });
  }

  carregarMapa() {
    const { filtros } = this.state;
    const params = { apenas_abertas: '1' };
    Object.keys(filtros).forEach(key => {
      if (filtros[key] !== '' && (filtros[key] !== null && filtros[key] !== undefined)) {
        params[key] = filtros[key];
      }
    });

    this.setState({ loading: true, centroFallback: null, markerAberto: null, osTabAtiva: 0 });
    this.pontosBoundsKey = '';
    axiosInstance
      .get('/manutencao/ordens_servico/mapa', { params })
      .then(resp => {
        const data = resp.data || {};
        const centro = data.centro || null;
        const pontos = normalizarPontos(data.pontos);
        this.setState(
          {
            centro,
            pontos,
            totalOs: data.total_os || 0,
            totalPontos: pontos.length,
            loading: false,
          },
          () => {
            if (this.mapRef) {
              this.ajustarMapaAosPontos(this.mapRef);
            }
          },
        );
        if (!centroValido(centro)) {
          return this.carregarCentroFallback(filtros.grupo_fisico_id);
        }
        return null;
      })
      .catch(() => {
        toastr.error('Erro', 'Não foi possível carregar o mapa de OS.');
        this.setState({ loading: false });
        return this.carregarCentroFallback(filtros.grupo_fisico_id);
      });
  }

  handleFiltroChange(e) {
    const { name, value } = e.target;
    this.setState(
      prev => ({
        filtros: { ...prev.filtros, [name]: value },
      }),
      this.carregarMapa,
    );
  }

  onMapLoad(mapRef) {
    if (!mapRef) return;
    this.mapRef = mapRef;
    this.ajustarMapaAosPontos(mapRef);
  }

  ajustarMapaAosPontos(mapRef) {
    const { pontos } = this.state;
    if (!mapRef || !window.google || !window.google.maps || pontos.length === 0) return;

    const boundsKey = pontos.map(p => `${p.controlador_id}:${p.latitude}:${p.longitude}`).join('|');
    if (this.pontosBoundsKey === boundsKey) return;
    this.pontosBoundsKey = boundsKey;

    const bounds = new window.google.maps.LatLngBounds();
    pontos.forEach(ponto => {
      bounds.extend({ lat: ponto.latitude, lng: ponto.longitude });
    });

    if (!bounds.isEmpty()) {
      mapRef.fitBounds(bounds);
    }
  }

  abrirMarker(controladorId) {
    this.setState(prev => ({
      markerAberto: controladorId,
      osTabAtiva: String(prev.markerAberto) === String(controladorId) ? prev.osTabAtiva : 0,
    }));
  }

  fecharMarker() {
    this.setState({ markerAberto: null, osTabAtiva: 0 });
  }

  selecionarOsTab(index, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({ osTabAtiva: index });
  }

  abrirOs(os) {
    if (!os || !os.id || this.abrindoOs) return;
    this.abrindoOs = true;
    this.props
      .openOsFromMap(os.id)
      .then(() => {
        this.props.history.push('/manutencao-os');
      })
      .finally(() => {
        this.abrindoOs = false;
      });
  }

  handleIniciarOs(os) {
    if (this.alterandoStatusOs) return;
    this.alterandoStatusOs = true;
    this.props
      .iniciarOs(os, () => this.carregarMapa())
      .finally(() => {
        this.alterandoStatusOs = false;
      });
  }

  handleFinalizarOs(os) {
    this.props.finalizarOs(os, () => {
      this.setState({ markerAberto: null });
      this.carregarMapa();
    });
  }

  getCentroExibicao() {
    const { centro, centroFallback, pontos } = this.state;
    if (centroValido(centro)) return centro;
    if (pontos.length > 0) {
      const lat = pontos.reduce((sum, p) => sum + p.latitude, 0) / pontos.length;
      const lng = pontos.reduce((sum, p) => sum + p.longitude, 0) / pontos.length;
      return { latitude: lat, longitude: lng };
    }
    if (centroValido(centroFallback)) return centroFallback;
    return null;
  }

  renderInfoRow(label, value, valueClassName = '') {
    if (value === undefined || value === null || value === '') return null;

    return (
      <div className="mapa-fases-info-row">
        <span className="mapa-fases-info-row-label">{label}</span>
        <span className={`mapa-fases-info-row-value ${valueClassName}`}>{value}</span>
      </div>
    );
  }

  renderOsBadges(os) {
    const statusLabel = STATUS_LABELS[os.status] || os.status;
    const prioridadeLabel = PRIORIDADE_LABELS[os.prioridade] || os.prioridade;
    const tipoLabel = TIPO_LABELS[os.tipo] || os.tipo;
    const statusClass = STATUS_BADGE_CLASS[os.status] || 'mapa-os-status-badge--gray';
    const prioridadeClass = PRIORIDADE_BADGE_CLASS[os.prioridade] || 'mapa-os-prioridade-badge--media';
    const tipoClass = TIPO_BADGE_CLASS[os.tipo] || 'mapa-os-tipo-badge--corretiva';
    const slaTexto = formatSlaRestante(os);

    return (
      <div className="mapa-os-info-badges-wrap">
        <div className="mapa-os-info-badges">
          <span className={`mapa-os-status-badge ${statusClass}`}>{statusLabel}</span>
          <span className={`mapa-os-prioridade-badge ${prioridadeClass}`}>{prioridadeLabel}</span>
          <span className={`mapa-os-tipo-badge ${tipoClass}`}>{tipoLabel}</span>
        </div>
        {temSlaAtivo(os) && slaTexto ? (
          <span className={`mapa-os-sla-tempo ${isSlaVencido(os) ? 'is-vencido' : ''}`}>{slaTexto}</span>
        ) : null}
      </div>
    );
  }

  renderOsPanel(os) {
    return (
      <>
        <div className="mapa-os-info-os-body">
          {this.renderInfoRow('Título', os.titulo, 'is-highlight')}
          {this.renderInfoRow('Equipe', formatEquipeResponsavel(os))}
          {this.renderInfoRow('Notificação', os.mensagem_erro)}
          {this.renderInfoRow(
            'Abertura',
            os.data_abertura ? new Date(os.data_abertura).toLocaleString('pt-BR') : null,
          )}
          {this.renderInfoRow('Última interação', formatUltimaInteracao(os))}
        </div>
        <div className="mapa-os-info-actions">
          <button
            type="button"
            className="mapa-os-info-link-btn mapa-os-info-link-btn--compact"
            onClick={() => this.abrirOs(os)}
            title="Ver ordem de serviço"
          >
            <span className="mapa-os-info-link-btn-label">
              <i className="fa fa-clipboard-list" aria-hidden="true" />
              Ver OS
            </span>
            <i className="fa fa-chevron-right mapa-os-info-link-btn-arrow" aria-hidden="true" />
          </button>
          {podeIniciarOs(os) ? (
            <button
              type="button"
              className="mapa-os-info-fluxo-btn mapa-os-info-fluxo-btn--iniciar"
              onClick={() => this.handleIniciarOs(os)}
              title="Iniciar atendimento"
            >
              Iniciar
            </button>
          ) : null}
          {podeFinalizarOs(os) ? (
            <button
              type="button"
              className="mapa-os-info-fluxo-btn mapa-os-info-fluxo-btn--finalizar"
              onClick={() => this.handleFinalizarOs(os)}
              title="Finalizar ordem de serviço"
            >
              Finalizar
            </button>
          ) : null}
        </div>
      </>
    );
  }

  renderInfoWindow(ponto) {
    const endereco = [ponto.cruzamento, ponto.endereco].filter(Boolean).join(' — ') || 'Não informado';
    const ordens = ponto.ordens || [];
    const multiplasOs = ordens.length > 1;
    const tabAtiva = Math.min(this.state.osTabAtiva, Math.max(ordens.length - 1, 0));
    const osAtiva = ordens[tabAtiva] || ordens[0] || null;

    return (
      <InfoWindow onCloseClick={this.fecharMarker}>
        <div
          className={`mapa-fases-info-window mapa-os-info-window ${
            multiplasOs ? 'mapa-os-info-window--multi' : ''
          }`}
        >
          <div className="mapa-fases-info-body mapa-os-info-body-top mapa-os-info-body-context">
            {this.renderInfoRow('Grupo físico', ponto.grupo_fisico_descricao)}
            {this.renderInfoRow('Controlador', `Ctrl ${String(ponto.controlador_numero).padStart(2, '0')}`)}
            {this.renderInfoRow('Endereço', endereco)}
          </div>

          {multiplasOs ? (
            <div className="mapa-os-info-multi">
              <div className="mapa-os-info-tabs" role="tablist" aria-label="Ordens de serviço">
                {ordens.map((os, index) => (
                  <button
                    key={os.id}
                    type="button"
                    role="tab"
                    aria-selected={index === tabAtiva}
                    className={`mapa-os-info-tab ${index === tabAtiva ? 'is-active' : ''}`}
                    onClick={event => this.selecionarOsTab(index, event)}
                  >
                    {os.numero}
                  </button>
                ))}
              </div>
              {osAtiva ? (
                <div className="mapa-os-info-panel" role="tabpanel">
                  <div className="mapa-fases-info-header mapa-os-info-header mapa-os-info-header--tab">
                    {this.renderOsBadges(osAtiva)}
                  </div>
                  {this.renderOsPanel(osAtiva)}
                </div>
              ) : null}
            </div>
          ) : (
            <>
              {osAtiva && (
                <div className="mapa-fases-info-header mapa-os-info-header">
                  {this.renderOsBadges(osAtiva)}
                </div>
              )}
              {osAtiva ? <div className="mapa-os-info-panel mapa-os-info-panel--single">{this.renderOsPanel(osAtiva)}</div> : null}
            </>
          )}
        </div>
      </InfoWindow>
    );
  }

  renderMarkers() {
    const { pontos, markerAberto } = this.state;

    return pontos.map(ponto => {
      const contKey = String(ponto.controlador_id);
      const position = { lat: ponto.latitude, lng: ponto.longitude };

      return (
        <Marker
          key={contKey}
          position={position}
          icon={iconePonto(ponto)}
          label={
            ponto.ordens && ponto.ordens.length > 1
              ? { text: String(ponto.ordens.length), color: '#fff', fontSize: '11px', fontWeight: 'bold' }
              : undefined
          }
          onClick={() => this.abrirMarker(ponto.controlador_id)}
        >
          {String(markerAberto) === contKey && this.renderInfoWindow(ponto)}
        </Marker>
      );
    });
  }

  renderMapa() {
    const { googleMapsReady, loading } = this.state;
    const centroExibicao = this.getCentroExibicao();

    if (!googleMapsReady) {
      return (
        <div
          className="mapa-fases-premium-empty"
          style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <i className="fa fa-spinner fa-spin" style={{ fontSize: 42, marginBottom: 20, opacity: 0.6 }} />
            <h4 style={{ fontWeight: 400, marginBottom: 8 }}>Carregando Google Maps</h4>
            <p style={{ margin: 0, fontSize: 14, opacity: 0.8 }}>Aguarde enquanto o mapa é preparado.</p>
          </div>
        </div>
      );
    }

    if (!centroExibicao) {
      return (
        <div
          className="mapa-fases-premium-empty"
          style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <i className="fa fa-map-marked-alt" style={{ fontSize: 48, marginBottom: 20, opacity: 0.5 }} />
            <h4 style={{ fontWeight: 400, marginBottom: 8 }}>Sem coordenadas cadastradas</h4>
            <p style={{ margin: 0, fontSize: 14, opacity: 0.8 }}>
              Cadastre latitude e longitude nos controladores ou selecione outro grupo físico.
            </p>
          </div>
        </div>
      );
    }

    return (
      <>
        {loading && (
          <div className="mapa-os-premium-loading">
            <i className="fa fa-spinner fa-spin" />
          </div>
        )}
        <MapaGoogle
          containerElement={<div style={{ height: '100%', width: '100%' }} />}
          mapElement={<div style={{ height: '100%' }} />}
          defaultCenter={{
            lat: parseCoord(centroExibicao.latitude),
            lng: parseCoord(centroExibicao.longitude),
          }}
          defaultZoom={14}
          onMapLoad={this.onMapLoad}
        >
          {this.renderMarkers()}
        </MapaGoogle>
      </>
    );
  }

  render() {
    const { opcoes, filtros, totalOs, totalPontos } = this.state;

    return (
      <div className="mapa-fases-premium mapa-os-premium">
        <OrdemServicoFinalizarModal />
        <div className="mapa-fases-premium-toolbar">
          <div
            className="mapa-fases-premium-toolbar-inner"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              flexWrap: 'wrap',
              gap: 12,
            }}
          >
            <div>
              <h2 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: '#2c3e50' }}>Mapa de OS</h2>
              <p style={{ margin: '2px 0 0', fontSize: 12, color: '#6c757d' }}>
                {totalOs} ordem(ns) em {totalPontos} cruzamento(s)
              </p>
            </div>

            <div
              className="mapa-fases-premium-controls"
              style={{ display: 'flex', alignItems: 'flex-end', gap: 12, flexWrap: 'wrap' }}
            >
              <div className="mapa-fases-premium-filter">
                <span className="mapa-fases-premium-label">Grupo físico</span>
                <select
                  className="form-control input-sm"
                  name="grupo_fisico_id"
                  value={filtros.grupo_fisico_id}
                  onChange={this.handleFiltroChange}
                >
                  <option value="">Todos</option>
                  {opcoes.grupos_fisicos.map(g => (
                    <option key={g.id} value={g.id}>
                      {g.descricao}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mapa-fases-premium-filter">
                <span className="mapa-fases-premium-label">Equipe</span>
                <select
                  className="form-control input-sm"
                  name="equipe_id"
                  value={filtros.equipe_id}
                  onChange={this.handleFiltroChange}
                >
                  <option value="">Todas</option>
                  {opcoes.equipes.map(e => (
                    <option key={e.id} value={e.id}>
                      {e.nome}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mapa-fases-premium-filter">
                <span className="mapa-fases-premium-label">Status</span>
                <select
                  className="form-control input-sm"
                  name="status"
                  value={filtros.status}
                  onChange={this.handleFiltroChange}
                >
                  <option value="">Todos (abertas)</option>
                  {Object.keys(STATUS_LABELS).map(key => (
                    <option key={key} value={key}>
                      {STATUS_LABELS[key]}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mapa-fases-premium-filter">
                <span className="mapa-fases-premium-label">Prioridade</span>
                <select
                  className="form-control input-sm"
                  name="prioridade"
                  value={filtros.prioridade}
                  onChange={this.handleFiltroChange}
                >
                  <option value="">Todas</option>
                  {Object.keys(PRIORIDADE_LABELS).map(key => (
                    <option key={key} value={key}>
                      {PRIORIDADE_LABELS[key]}
                    </option>
                  ))}
                </select>
              </div>

              <button
                type="button"
                className="btn btn-default btn-sm mapa-os-refresh-btn"
                onClick={this.carregarMapa}
                title="Atualizar"
                aria-label="Atualizar"
              >
                <i className="fa fa-sync-alt" />
              </button>
            </div>
          </div>
        </div>

        <div className="mapa-fases-premium-content" style={{ padding: '0 10px', margin: 0 }}>
          <div
            className="mapa-fases-premium-layout"
            style={{
              display: 'flex',
              height: 'calc(100vh - 100px)',
              gap: '15px',
            }}
          >
            <div className="mapa-fases-premium-map-card mapa-os-premium-map-card">
              {this.renderMapa()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    null,
    dispatch => bindActionCreators({ openOsFromMap, iniciarOs, finalizarOs }, dispatch),
  )(MapaOrdemServico),
);
